// Drop Zone v2 — noise filtering (spec #761, §B.5).
//
// Pure, node-free: shared by the browser/entries pass and the node folder scan
// so both strip the same hidden files before classifying. The user is never
// told this happened — it just happens (spec §B.5).

import type { DropEntry } from './types.js';

const NOISE_SEGMENTS = new Set<string>([
  '.git',
  'node_modules',
  '.svn',
  '.hg',
  '__pycache__',
  '.next',
  '.cache',
  '.venv',
  'venv',
]);
const NOISE_BASENAMES = new Set<string>(['.ds_store', 'thumbs.db']);

/** True when a single path segment (dir or file name) is noise. */
export function isNoiseSegment(segment: string): boolean {
  return NOISE_SEGMENTS.has(segment.toLowerCase());
}

/** True when any segment of the path is a noise dir, or the file itself is noise. */
export function isNoisePath(path: string): boolean {
  const segments = path.split('/').filter((s) => s.length > 0);
  if (segments.length === 0) return true;
  for (const seg of segments) {
    if (NOISE_SEGMENTS.has(seg.toLowerCase())) return true;
  }
  const base = segments[segments.length - 1] ?? '';
  return NOISE_BASENAMES.has(base.toLowerCase());
}

/** Drop every noise entry from a dropped file list. */
export function filterNoise(entries: DropEntry[]): DropEntry[] {
  return entries.filter((e) => !isNoisePath(e.path));
}
